@import '../../vars.css';

.footer {
    border-bottom-left-radius: var(--modal-border-radius);
    border-bottom-right-radius: var(--modal-border-radius);
}

.sticky {
    bottom: calc(var(--modal-vertical-padding) * -1);

    &.fullscreen {
        bottom: var(--gap-0);
    }
}

.size-500,
.size-600,
.size-800,
.size-1140,
.fullscreen {
    padding: var(--modal-s-footer-paddings);
}
